import React, { useState, useEffect, useRef } from 'react';
import {
  AllCategoriesContainer,
  Sidebar,
  EachCategoryContainer,
  SidebarContainer,
} from './styled';
import { categorySideBarDataFetcher } from '../../datafetchers/CategoryPage';
import ProductCardHome from '../NewStoreHomeWeb/BestsellerNew/ProductCardHome';
import { SkeletonBox } from '../Product/Skeleton/styled';
import GlobalStyle from '../../styles/globalStylesV2';

const AllCategories = () => {
  const [categoryData, setCategoryData] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedTermId, setSelectedTermId] = useState('');
  const [selectedCategoryData, setSelectedCategoryData] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const categoryContainerRef = useRef(null);
  const sidebarContainerRef = useRef(null);

  const scrollSidebarToCategory = () => {
    if (!sidebarContainerRef.current) return;

    const selectedElement =
      sidebarContainerRef.current.querySelector('.selected');
    if (selectedElement) {
      selectedElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  const makeSelectedCategoryData = async () => {
    if (selectedTermId) {
      if (categoryContainerRef.current) {
        categoryContainerRef.current.style.scrollBehavior = 'auto';
        categoryContainerRef.current.scrollTop = 0;
        setTimeout(() => {
          categoryContainerRef.current.style.scrollBehavior = 'smooth';
        }, 0);
      }
      setIsAnimating(true);

      const firstTermId = categoryData?.data?.tabList[0]?.tabs[0]?.term_id;

      if (selectedTermId === firstTermId) {
        const cachedCategoryData = sessionStorage.getItem(
          `category_${selectedTermId}`,
        );
        if (cachedCategoryData) {
          setSelectedCategoryData(JSON.parse(cachedCategoryData));
          setIsAnimating(false);
        } else {
          const data = await categorySideBarDataFetcher(selectedTermId);
          setSelectedCategoryData(data);
          sessionStorage.setItem(
            `category_${selectedTermId}`,
            JSON.stringify(data),
          );
        }
      } else {
        const data = await categorySideBarDataFetcher(selectedTermId);
        setSelectedCategoryData(data);
      }
    }

    setTimeout(() => {
      setIsAnimating(false);
    }, 500);

    scrollSidebarToCategory();

    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  };

  const createLeftTabsData = async () => {
    const cachedData = sessionStorage.getItem('tabList');
    if (cachedData) {
      const data = JSON.parse(cachedData);
      setCategoryData(data);
      if (data?.data?.tabList[0]?.tabs[0]) {
        setSelectedTermId(data.data.tabList[0].tabs[0].term_id);
      }
      return;
    } else {
      const data = await categorySideBarDataFetcher();
      setCategoryData(data);
      if (data?.data?.tabList[0]?.tabs[0]) {
        setSelectedTermId(data.data.tabList[0].tabs[0].term_id);
      }
      sessionStorage.setItem('tabList', JSON.stringify(data));
    }
  };

  useEffect(() => {
    createLeftTabsData();
  }, []);

  useEffect(() => {
    makeSelectedCategoryData();
  }, [selectedTermId]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const button = entry.target;
        button.classList.toggle('shakeanimation', entry.isIntersecting);
      },
      { threshold: 0.5 },
    );

    const button = document.querySelector('.GoToNextCategory button');
    if (button) observer.observe(button);
    return () => button && observer.unobserve(button);
  }, []);

  return (
    <>
      <GlobalStyle />
      <AllCategoriesContainer>
        <SidebarContainer ref={sidebarContainerRef}>
          {!categoryData?.data.tabList?.length
            ? Array(6)
                .fill(0)
                .map((_, index) => (
                  <div key={index} className="productCategoryCard">
                    <SkeletonBox height="200px" width="100%" />
                    <SkeletonBox
                      height="20px"
                      width="80%"
                      style={{ marginTop: '10px' }}
                    />
                    <div className="imageWithText">
                      <SkeletonBox height="10px" width="50%" />
                    </div>
                    <div className="imageWithText">
                      <SkeletonBox height="10px" width="50%" />
                    </div>
                  </div>
                ))
            : categoryData?.data.tabList.map((tab, index) => (
                <Sidebar key={index}>
                  <img
                    src={tab.image || null}
                    alt={`category-${index}`}
                    width="100%"
                    height="100%"
                  />
                  <hr />
                  <div className="itemContainer">
                    {tab.tabs.map((tabItem, tabIndex) => (
                      <div
                        key={tabIndex}
                        className={`singleContainer ${
                          selectedCategory === tabItem.description ||
                          (index === 0 && tabIndex === 0 && !selectedCategory)
                            ? 'selected'
                            : ''
                        }`}
                        onClick={() => {
                          setSelectedTermId(tabItem.term_id);
                          setSelectedCategory(tabItem.description);
                        }}
                      >
                        <img
                          src={tabItem.circular_icon || null}
                          alt={`icon-${index}-${tabIndex}`}
                          width="78%"
                        />
                        <p>{tabItem.description || null}</p>
                      </div>
                    ))}
                  </div>
                </Sidebar>
              ))}
        </SidebarContainer>

        <EachCategoryContainer
          ref={categoryContainerRef}
          isAnimating={isAnimating}
        >
          {isAnimating ? (
            <SkeletonBox height="18%" width="100%" />
          ) : selectedCategoryData?.data?.topBanner?.image ? (
            <img
              className="topBanner"
              src={selectedCategoryData.data.topBanner.image}
              alt=""
              width="100%"
              onClick={() =>
                (window.location.href =
                  selectedCategoryData.data.topBanner.webUrl)
              }
            />
          ) : null}
          <div className="productCategoryContainer">
            {isAnimating
              ? Array(6)
                  .fill(0)
                  .map((_, index) => (
                    <div key={index} className="productCategoryCard">
                      <SkeletonBox height="200px" width="100%" />
                      <SkeletonBox
                        height="20px"
                        width="80%"
                        style={{ marginTop: '10px' }}
                      />
                      <div className="imageWithText">
                        <SkeletonBox height="10px" width="50%" />
                      </div>
                      <div className="imageWithText">
                        <SkeletonBox height="10px" width="50%" />
                      </div>
                    </div>
                  ))
              : selectedCategoryData?.data?.tagsDetails?.[0]?.childTagsDetails?.map(
                  (product, index) => (
                    <div key={index} className="productCategoryCard">
                      <img
                        src={product.image}
                        alt={`product-${index}`}
                        width="100%"
                        height="100%"
                        onClick={() => (window.location.href = product.web_url)}
                      />
                      <p className="productHeading">{product.description}</p>
                      <div className="imageWithText">
                        {product.productSoldCount && (
                          <img
                            src="https://images.myloapp.in/NestJsUploads/1743159779037-my-orders.webp"
                            alt=""
                            width="16px"
                            height="16px"
                          />
                        )}
                        <p>{product.productSoldCount}</p>
                      </div>
                      <div className="imageWithText">
                        {product.productReviewsCount && (
                          <img
                            src="https://images.myloapp.in/NestJsUploads/1743159624789-thumb.webp"
                            alt=""
                            width="16px"
                            height="16px"
                          />
                        )}
                        <p>{product.productReviewsCount}</p>
                      </div>
                    </div>
                  ),
                )}
          </div>
          <div className="trendingInCategory">
            <h3 className="trendingHeading">
              {selectedCategoryData?.data?.generalItems?.[0]?.heading}
            </h3>

            <div className="trendingProducts">
              {selectedCategoryData?.data?.generalItems?.[0]?.items.map(
                (element, index) => (
                  <ProductCardHome
                    isAllCategoryPage={true}
                    itemId={`element-${index}`}
                    productInfo={element}
                    key={`element-${element?.id || index}`}
                    store={true}
                  />
                ),
              )}
            </div>
          </div>
          <div className="GoToNextCategory">
            <button
              onClick={() => {
                const tabList = categoryData?.data.tabList || [];
                const flattenedTabs = tabList.reduce(
                  (acc, tab) => [...acc, ...tab.tabs],
                  [],
                );
                const currentIndex = flattenedTabs.findIndex(
                  (item) => item.term_id === selectedTermId,
                );

                if (currentIndex !== -1) {
                  const nextItem =
                    flattenedTabs[(currentIndex + 1) % flattenedTabs.length];
                  setSelectedTermId(nextItem.term_id);
                  setSelectedCategory(nextItem.description);
                }
              }}
            >
              Go To{' '}
              {(() => {
                const tabs =
                  categoryData?.data.tabList?.reduce(
                    (acc, tab) => [...acc, ...tab.tabs],
                    [],
                  ) || [];
                const nextIndex =
                  (tabs.findIndex((item) => item.term_id === selectedTermId) +
                    1) %
                  tabs.length;
                return tabs[nextIndex]?.description || 'Next Category';
              })()}
            </button>
          </div>
        </EachCategoryContainer>
      </AllCategoriesContainer>
    </>
  );
};

export default AllCategories;
